import script from "./SummaryControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryControls.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryControls.vue?vue&type=style&index=0&id=c8723bb2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8723bb2"]])

export default __exports__